/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import type { GetLanguages200, InternalServerErrorResponse } from ".././model";

import { customInstance } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Returns the static language information as defined in the x-language-info component, providing language codes with their English and native labels.
 * @summary Get all available language options
 */
export const getLanguages = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetLanguages200>(
    {
      url: `https://api.app.usesky.ai/organizations/languages`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetLanguagesQueryKey = () => {
  return [`https://api.app.usesky.ai/organizations/languages`] as const;
};

export const getGetLanguagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getLanguages>>,
  TError = InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLanguagesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLanguages>>> = ({
    signal,
  }) => getLanguages(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLanguages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLanguagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLanguages>>
>;
export type GetLanguagesQueryError = InternalServerErrorResponse;

export function useGetLanguages<
  TData = Awaited<ReturnType<typeof getLanguages>>,
  TError = InternalServerErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLanguages>>,
          TError,
          Awaited<ReturnType<typeof getLanguages>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLanguages<
  TData = Awaited<ReturnType<typeof getLanguages>>,
  TError = InternalServerErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLanguages>>,
          TError,
          Awaited<ReturnType<typeof getLanguages>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLanguages<
  TData = Awaited<ReturnType<typeof getLanguages>>,
  TError = InternalServerErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all available language options
 */

export function useGetLanguages<
  TData = Awaited<ReturnType<typeof getLanguages>>,
  TError = InternalServerErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetLanguagesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
